import styled from 'styled-components'

export const InfoBox = styled.div`
display: flex;
align-items: center;
justify-content: center;
background: var(--terc5);
color: var(--c7);
border-radius: 0.625rem;
height: 5.625rem;
width: 10.625rem;
box-shadow: var(--SombraBtns);

div{
    width: min-content;
    margin-left: .5rem;
}
`

export const StyledTd = styled.td`
    color: ${props => props.theme};
    font-weight: bold;
`

export const TableDiv = styled.div`
display: flex;
justify-content: center;
table, th, td {
  border: 0.063rem solid var(--c6);
  border-collapse: collapse;
  font-family: 'Roboto','sans-serif';
}

table{
    width: 100%;
}

th,td{
    max-width: 12rem;
    padding: .5rem 1rem .5rem 1rem;
}

td{
    transition: 2s;
    text-align: center;
}

th{
    background: var(--Roxo);
    color: var(--c1);
    font-weight: 500;
}
tr:last-child, tr:last-child:hover{
    background: var(--c3);
}
td:first-child{
    background: var(--RoxoOpaco25);
    color: var(--Preto);
    font-weight: bold;
}
.dropDownTr{
    background: var(--RoxoOpaco15) !important;
    color: var(--Preto);
    font-weight: bold;
}
tr:hover{
background: var(--RoxoOpaco25);
}

tr:not(:first-child){
color: var(--Preto);
}
`

export const ComentariosContainer = styled.div`
display: flex;
justify-content: start;
width: 100%;
background: var(--c2);
padding: .5rem;
width: 100%;
flex-direction: column;

h3{
    color: var(--Gray3);
    margin-bottom: 1rem;
}
`

export const Titulo = styled.h2`
font-family: 'Poppins';
font-weight: 500;
font-size: 28px;
color: #2C4D8A;
margin-bottom: 1rem;
`
